import { render } from "./App.vue?vue&type=template&id=783d86b8&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=783d86b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-783d86b8"

export default script